/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from "react";
import DOWNLOAD_IMG from "../../assets/images/download.svg";
import LOADING_IMG from "../../assets/images/icons/loading.svg";

import styles from "./download.module.scss";

interface IProps {
  fileName: string;
  filePath: string;
  nameClass?: string;
  filesDownloading: any;
  regions: any;
  downloadingRegion: any;
  project: "nuScenes" | "nuPlan";
  downloadFile: (
    file: string,
    region: string,
    project: "nuScenes" | "nuPlan"
  ) => Promise<void>;
}

const DownloadLink: FC<IProps> = (props: IProps) => {
  const download =
    (file: string, region: string, project: "nuScenes" | "nuPlan") => (e) => {
      e.preventDefault();
      const { filesDownloading } = props;
      const isGeneratingUrl = filesDownloading.indexOf(file) >= 0;
      !isGeneratingUrl && props.downloadFile(file, region, project);
    };

  const {
    fileName,
    filePath,
    nameClass,
    filesDownloading,
    regions,
    downloadingRegion,
    project,
  } = props;
  const isGeneratingUrl = filesDownloading.indexOf(filePath) >= 0;
  return (
    <div className={`${styles.archive}`}>
      <img
        src={DOWNLOAD_IMG}
        alt="download"
        className={styles["download-icon"]}
      />
      <div className={`flex-only ${nameClass ? nameClass : ""}`}>
        {fileName}&nbsp;&nbsp;
        {filePath && regions.length > 0 && (
          <div>
            [
            {regions.map((r, index) => (
              <span key={r.id}>
                {isGeneratingUrl && downloadingRegion === r.id ? (
                  <img src={LOADING_IMG} alt="" className={styles.loaderIcon} />
                ) : (
                  <a href="#" onClick={download(filePath, r.id, project)}>
                    {r.name}
                  </a>
                )}
                {index < regions.length - 1 ? ", " : ""}
              </span>
            ))}
            ]
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadLink;
